import { z } from "zod";

import { MetadataSchema } from "api/schemas/common";

const GetUnsignedNotesArgsSchema = z.object({
  health_care_organization_id: z.number(),
  params: z
    .object({
      limit: z.number().optional(),
      page: z.number().optional(),
    })
    .optional(),
});
export type GetUnsignedNotesArgs = z.infer<typeof GetUnsignedNotesArgsSchema>;

const UnsignedNoteSchema = z.object({
  care_event_id: z.number(),
  cpt_codes: z.array(z.string()),
  label: z.string(),
  patient_id: z.number(),
  patient_name: z.string(),
  review_state: z.string(),
  start_time: z.string(),
  therapist_id: z.number(),
  therapist_name: z.string(),
});
export type UnsignedNote = z.infer<typeof UnsignedNoteSchema>;

export const GetUnsignedNotesResponseSchema = z.object({
  items: z.array(UnsignedNoteSchema),
  metadata: MetadataSchema,
});
